import React from "react";
import "./Footer.css";
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';

const Footer = () => {
  return (
    <div className="footer"  style={{paddingTop: 15}}>
    <Button variant="primary" href="/" style={{backgroundColor: '#2E41FF', padding: 10, borderRadius: 4, textDecoration: 'none'}}>Reload Page</Button>
      <hr style={{ width: "90%", marginTop: 20 }} />
      <span className="name">
        Developed by{" "}
        <a href="https://alluring-wizard.tech/" target="_blank" style={{textDecoration: 'none'}}>
          Alluring Wizard
        </a>
      </span>
    </div>
  );
};

export default Footer;
